import { faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractSubmitStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { AbstractSubmitStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { FormDecidable, FormNumber, ProgressButton } from "@/shared/ui";
import { DEFAULT_PARAMS } from "../data";

export interface StepFields {
	numberOfChildrenCurrent: number;
	numberOfChildrenCommitment: number;
	eligibleForCsokPlus: boolean;
	inKhr: boolean;
	qualifiesForVoluntaryInterestRateCap: boolean;
}
export interface Props extends AbstractSubmitStepProps {
	variant?: string;
}
export class Step2 extends AbstractSubmitStep<StepFields, Props> {
	protected initValues(): StepFields {
		const {
			numberOfChildrenCurrent,
			numberOfChildrenCommitment,
			eligibleForCsokPlus,
			qualifiesForVoluntaryInterestRateCap,
			inKhr,
		} = DEFAULT_PARAMS;

		return {
			numberOfChildrenCurrent,
			numberOfChildrenCommitment,
			eligibleForCsokPlus,
			inKhr,
			qualifiesForVoluntaryInterestRateCap,
		};
	}
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState, variant } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center pb-1 pt-3">
					<div className="display-3 text-uppercase">
						<strong>{variant === "freeUse" ? "Jelzáloghitel" : "Lakáshitel"} kalkulátor</strong>
					</div>
					<div className="display-6 text-uppercase">
						<b>Spórolj akár Milliókat</b>
					</div>
				</Card.Header>
				<Card.Body>
					<FormNumber
						label="Meglévő gyermekek"
						name="numberOfChildrenCurrent"
						infoTooltip="Csak a meglévő gyermekek számát írd be."
						validate={this.validChildNumber}
						required
					/>
					<FormNumber
						label="Tervezett gyermekek"
						infoTooltip="CSOK PLUSZ hitel esetén minimum 1 vállalt gyermek szükséges. A 12 hetes magzat még vállaltnak minősül."
						name="numberOfChildrenCommitment"
						validate={this.validChildNumber}
						required
					/>
					<FormDecidable
						label="Jogosult vagyok CSOK PLUSZ-ra"
						name="eligibleForCsokPlus"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Megfelelek az önkéntes kamatplafon előírásainak"
						name="qualifiesForVoluntaryInterestRateCap"
						infoTooltip="35 év alatti vagyok és első lakásom vásárolnám meg a kölcsönből. Az épület „A+” vagy annál kedvezőbb energetikai besorolású és a primer-energiaigénye nem haladja meg a 68 kWh/m2/év értéket. Az épület alapterülete nem haladja meg a 60 négyzetmétert. A lakás vételára nem haladja meg az 1 200 000 Ft/m2 értéket."
						required
					/>
					<FormDecidable
						label="Szerepelsz a negatív adósok listáján a KHR-ben?"
						name="inKhr"
						disabled={disabled}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						state={submitState}
						className={`${!form.getState().valid ? "disabled" : ""} text-uppercase font-weight-bold`}
					>
						{variant === "freeUse" ? "Jelzáloghitelek" : "Lakáshitelek"} keresése
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}
	@autobind
	private validChildNumber(childNumber: number): string {
		if (isNaN(childNumber)) {
			return "Gyermekek számának megadása kötelező!";
		}

		if (childNumber < 0) {
			return "Nullánál kisebb szám nem adható meg.";
		}

		if (childNumber > 10) {
			return "Tíznél nagyobb szám nem adható meg.";
		}
	}
	protected getComponentName(): string {
		return "Step2";
	}
}
